import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import ConfirmDialog from "../ConfirmDialog";
import "./style.css";

const BlogModal = ({
  onClose,
  onSave,
  onDelete,
  initialHeading,
  initialContent,
  initialDate,
  initialImage,
  initialCategory,
}) => {
  const [heading, setHeading] = useState(initialHeading);
  const [content, setContent] = useState(initialContent);
  const [date, setDate] = useState(initialDate);
  const [image, setImage] = useState(initialImage);
  const [category, setCategory] = useState(initialCategory);
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const history = useHistory();

  const handleSave = () => {
    onSave(heading, content, date, image, category);
    onClose();
  };

  const handleDelete = () => {
    setShowConfirmDialog(true);
  };

  const handleConfirmDelete = () => {
    onDelete();
    onClose();
    history.push("/DeleteBlog");
  };

  const handleCancelDelete = () => {
    setShowConfirmDialog(false);
  };

  const handleImageChange = (e) => {
    const selectedImage = e.target.files[0];
    setImage(selectedImage);
  };

  return (
    <div className="modal-overlay">
      <div className="blog-modal">
        <h2>Edit Blog Post</h2>
        <input
          type="text"
          placeholder="Blog Header"
          value={heading}
          onChange={(e) => setHeading(e.target.value)}
        />
        <input
          type="date"
          value={date}
          onChange={(e) => setDate(e.target.value)}
        />
        <input
          type="file"
          accept="image/*"
          onChange={handleImageChange}
        />
        <input
          type="text"
          placeholder="Blog Category"
          value={category}
          onChange={(e) => setCategory(e.target.value)}
        />
        <textarea
          placeholder="Blog Content"
          value={content}
          onChange={(e) => setContent(e.target.value)}
          rows="10"
        />
        <div className="button-container">
          <button onClick={handleSave}>Update</button>
          <button onClick={handleDelete}>Delete</button>
          <button onClick={onClose}>Close</button>
        </div>
      </div>

      {showConfirmDialog && (
        <ConfirmDialog
          message="Do you want to delete the blog?"
          onConfirm={handleConfirmDelete}
          onCancel={handleCancelDelete}
        />
      )}
    </div>
  );
};

export default BlogModal;
